import React from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import Moment from "react-moment";
import { FiMoreHorizontal, FiRepeat } from "react-icons/fi";
import { Row, Col, Dropdown, FormGroup, FormControl } from "react-bootstrap";
import DataTable from "components/DataTable";
import { Desktop, Mobile, Tablet } from "utils/responsive";
import "./ShiftExchangesList.scss";
import {
	planAssignmentExchangesService,
	exchangeStatus,
} from "services/planAssignmentExchangesService";
import { errorFormating } from "utils/utils";

class ShiftExchangesList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			answersById: {},
		};
	}

	async handleExchangeStatus(exchange, status) {
		const localAnswer = this.state.answersById[exchange.id];

		const requesterAssignmentId = exchange.requester_plan?.assignments?.[0]?.id;
		const targetAssignmentId = exchange.target_plan?.assignments?.[0]?.id;

		const updated = {
			...exchange,
			status,
			answer_comments:
				localAnswer !== undefined ? localAnswer : exchange.answer_comments,
			requester_plan_id: requesterAssignmentId ?? exchange.requester_plan_id,
			target_plan_id: targetAssignmentId ?? exchange.target_plan_id,
		};

		const response = await planAssignmentExchangesService.update(updated);

		if (response.ok) {
			toastr.success(
				this.props.t("common.success"),
				this.props.t("common.changesSaved")
			);
			this.setState((prev) => {
				const next = { ...prev.answersById };
				delete next[exchange.id];
				return { answersById: next };
			});
			await this.props.reloadExchanges();
		} else {
			const textError = errorFormating(response);
			this.props.openAlertModal(
				textError.general,
				this.props.t("shiftExchanges.errorManage")
			);
		}
	}

	handleChange = (event, exchange) => {
		const value = event.target.value;
		this.setState((prev) => ({
			answersById: { ...prev.answersById, [exchange.id]: value },
		}));
	};

	getShiftBadge(assignment) {
		const shift = assignment?.shift;
		if (!shift) return null;
		return (
			<span
				className="card-shift"
				style={{
					backgroundColor: shift.background_color || undefined,
					borderColor: shift.border_color || undefined,
				}}
			>
				{shift.name}
			</span>
		);
	}

	getStatusClass(status) {
		switch (status) {
			case exchangeStatus.approved:
				return "estado-si";
			case exchangeStatus.accepted:
				return "estado-pendiente-aprobacion";
			case exchangeStatus.denied:
				return "estado-no";
			case exchangeStatus.canceled:
				return "estado-anulado";
			default:
				return "estado-pendiente";
		}
	}

	getStatusLabel(status) {
		switch (status) {
			case exchangeStatus.pending:
				return this.props.t("shiftExchanges.statusPendingResponse");
			case exchangeStatus.accepted:
				return this.props.t("shiftExchanges.statusPendingApproval");
			default:
				return status;
		}
	}

	getAnswerCommentsLabel(status) {
		if (status === exchangeStatus.denied) {
			return this.props.t("shiftExchanges.rejectionReason");
		}
		if (
			status === exchangeStatus.accepted ||
			status === exchangeStatus.approved
		) {
			return this.props.t("shiftExchanges.acceptanceResponse");
		}
		return this.props.t("shiftExchanges.answerComments");
	}

	renderManagedActions(exchange) {
		const { t } = this.props;
		return (
			<Dropdown>
				<Dropdown.Toggle variant="action">
					<FiMoreHorizontal />
				</Dropdown.Toggle>
				<Dropdown.Menu>
					<Dropdown.Item as="button" onClick={() => this.props.openViewExchangeModal(exchange)}>
						{t("shiftExchanges.viewAction")}
					</Dropdown.Item>
					{exchange.status !== exchangeStatus.denied &&
						exchange.status !== exchangeStatus.canceled && (
						<Dropdown.Item as="button" onClick={() => this.props.cancelExchange(exchange)}>
							{t("shiftExchanges.cancelRequest")}
						</Dropdown.Item>
					)}
					<Dropdown.Item as="button" onClick={() => this.props.reopenExchange(exchange)}>
						{t("shiftExchanges.reopenRequest")}
					</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		);
	}

	getRows = () => {
		const { exchanges, t } = this.props;

		return exchanges.map((exchange) => {
			const isPending = exchange.status === exchangeStatus.pending;
			const isAwaitingApproval = exchange.status === exchangeStatus.accepted;
			const isCanceled = exchange.status === exchangeStatus.canceled;
			const localAnswer = this.state.answersById[exchange.id];

			const requesterAssignment = exchange.requester_plan?.assignments?.[0];
			const targetAssignment = exchange.target_plan?.assignments?.[0];
			const requesterDay = exchange.requester_plan?.day;
			const targetDay = exchange.target_plan?.day;

			const requesterEmployee = exchange.requester_employee;
			const targetEmployee = exchange.target_employee;

			return (
				<div className="col-sm-6 col-lg-4 col-xl-3" key={exchange.id}>
					<article className="card card-ausencia card-shift-exchange">
						<div className="card-content">

							<div className="exchange-card-header">
								{requesterEmployee && targetEmployee && (
									<p className="exchange-participants">
										<strong>{requesterEmployee.name} {requesterEmployee.surname}</strong>
									<span className="exchange-participants-arrow">›</span>
										<strong>{targetEmployee.name} {targetEmployee.surname}</strong>
									</p>
								)}
								<span className={`estado ${this.getStatusClass(exchange.status)}`}>
									{this.getStatusLabel(exchange.status)}
								</span>
							</div>

							{isAwaitingApproval && (
								<p className="exchange-status-help">
									{t("shiftExchanges.pendingApprovalHelp")}
								</p>
							)}

							<div className="shift-exchange-parties">
								<div className="shift-exchange-side">
									<Moment className="exchange-date" format="D/MM/YYYY">
										{requesterDay}
									</Moment>
									{this.getShiftBadge(requesterAssignment)}
								</div>

								<div className="shift-exchange-arrow">
									<FiRepeat />
								</div>

								<div className="shift-exchange-side">
									<Moment className="exchange-date" format="D/MM/YYYY">
										{targetDay}
									</Moment>
									{this.getShiftBadge(targetAssignment)}
								</div>
							</div>

							{(exchange.comments || exchange.answer_comments) && (
								<div className="exchange-comments">
									{exchange.comments && (
										<div className="exchange-comment">
											<strong>{t("shiftExchanges.requestComments")}</strong>
											<span>{exchange.comments}</span>
										</div>
									)}

									{exchange.answer_comments && (
										<div className="exchange-comment">
											<strong>{this.getAnswerCommentsLabel(exchange.status)}</strong>
											<span>{exchange.answer_comments}</span>
										</div>
									)}
								</div>
							)}

							{isPending && this.props.showActions && (
								<>
									<FormGroup className="form-group mt25" controlId="answer_comments">
										<FormControl
											as="textarea"
											value={
												localAnswer !== undefined
													? localAnswer
													: exchange.answer_comments || ""
											}
											onChange={(e) => this.handleChange(e, exchange)}
											className="answer-comments"
											placeholder={t("shiftExchanges.answerPlaceholder")}
										/>
									</FormGroup>

									<Row className="row-buttons">
										<Col sm={6}>
											<button
												type="button"
												className="btn btn-primary"
												onClick={() => this.handleExchangeStatus(exchange, exchangeStatus.accepted)}
											>
												{t("shiftExchanges.accept")}
											</button>
										</Col>
										<Col sm={6}>
											<button
												type="button"
												className="btn btn-secondary"
												onClick={() => this.handleExchangeStatus(exchange, exchangeStatus.denied)}
											>
												{t("shiftExchanges.reject")}
											</button>
										</Col>
									</Row>
								</>
							)}

							{isAwaitingApproval && this.props.showApprovalActions && (
								<Row className="row-buttons exchange-approval-actions">
									<Col sm={6}>
										<button
											type="button"
											className="btn btn-primary"
											onClick={() => this.handleExchangeStatus(exchange, exchangeStatus.approved)}
										>
											{t("shiftExchanges.approve")}
										</button>
									</Col>
									<Col sm={6}>
										<button
											type="button"
											className="btn btn-secondary"
											onClick={() => this.handleExchangeStatus(exchange, exchangeStatus.denied)}
										>
											{t("shiftExchanges.reject")}
										</button>
									</Col>
								</Row>
							)}

							<p className="card-label card-label-solicitado">
								{t("shiftExchanges.requestedOn")}{" "}
								<Moment className="tag-dia" format="D/MM/YYYY">
									{exchange.requested}
								</Moment>
							</p>

							{(isPending || isAwaitingApproval || isCanceled) && this.props.canEdit && (
								<div className="card-actions bottom-right">
									<Dropdown>
										<Dropdown.Toggle variant="action">
											<FiMoreHorizontal />
										</Dropdown.Toggle>
										<Dropdown.Menu>
											{isPending && (
												<Dropdown.Item
													as="button"
													onClick={() => this.props.openEditExchangeModal(exchange)}
												>
													{t("common.edit")}
												</Dropdown.Item>
											)}
											{!isCanceled && (
												<Dropdown.Item
													as="button"
													onClick={() => this.props.cancelOwnExchange(exchange)}
												>
													{t("shiftExchanges.cancelRequest")}
												</Dropdown.Item>
											)}
											{isCanceled && (
												<Dropdown.Item
													as="button"
													onClick={() => this.props.reopenOwnExchange(exchange)}
												>
													{t("shiftExchanges.reopenRequest")}
												</Dropdown.Item>
											)}
										</Dropdown.Menu>
									</Dropdown>
								</div>
							)}
							{this.props.showManagedActions && (
								<div className="card-actions bottom-right">
									{this.renderManagedActions(exchange)}
								</div>
							)}
						</div>
					</article>
				</div>
			);
		});
	};

	getTableRows = () =>
		this.props.exchanges.map((exchange) => {
			const requesterAssignment = exchange.requester_plan?.assignments?.[0];
			const targetAssignment = exchange.target_plan?.assignments?.[0];
			const requesterEmployee = exchange.requester_employee;
			const targetEmployee = exchange.target_employee;

			return (
				<tr key={exchange.id}>
					<td>
						<strong>{requesterEmployee?.name} {requesterEmployee?.surname}</strong>
					</td>
					<td>
						<strong>{targetEmployee?.name} {targetEmployee?.surname}</strong>
					</td>
					<td>
						<div className="exchange-table-shift">
							<Moment format="D/MM/YYYY">{exchange.requester_plan?.day}</Moment>
							{this.getShiftBadge(requesterAssignment)}
						</div>
					</td>
					<td>
						<div className="exchange-table-shift">
							<Moment format="D/MM/YYYY">{exchange.target_plan?.day}</Moment>
							{this.getShiftBadge(targetAssignment)}
						</div>
					</td>
					<td>
						<span className={`estado ${this.getStatusClass(exchange.status)}`}>
							{this.getStatusLabel(exchange.status)}
						</span>
					</td>
					<td className="exchange-table-comments">
						{exchange.comments || "—"}
					</td>
					<td className="exchange-table-comments">
						{exchange.answer_comments || "—"}
					</td>
					<td>
						<Moment format="D/MM/YYYY">{exchange.requested}</Moment>
					</td>
				</tr>
			);
		});

	getTableColumns = () => {
		const { t } = this.props;
		return [
			{
				key: "requester",
				header: t("shiftExchanges.requester"),
				className: "td-name",
				render: (exchange) => <strong>{exchange.requester_employee?.name} {exchange.requester_employee?.surname}</strong>,
			},
			{
				key: "target",
				header: t("shiftExchanges.target"),
				className: "td-name",
				render: (exchange) => <strong>{exchange.target_employee?.name} {exchange.target_employee?.surname}</strong>,
			},
			{
				key: "requester_shift",
				header: t("shiftExchanges.requesterShift"),
				render: (exchange) => (
					<div className="exchange-table-shift">
						<Moment format="D/MM/YYYY">{exchange.requester_plan?.day}</Moment>
						{this.getShiftBadge(exchange.requester_plan?.assignments?.[0])}
					</div>
				),
			},
			{
				key: "target_shift",
				header: t("shiftExchanges.targetShift"),
				render: (exchange) => (
					<div className="exchange-table-shift">
						<Moment format="D/MM/YYYY">{exchange.target_plan?.day}</Moment>
						{this.getShiftBadge(exchange.target_plan?.assignments?.[0])}
					</div>
				),
			},
			{
				key: "status",
				header: t("common.status"),
				render: (exchange) => (
					<span className={`estado ${this.getStatusClass(exchange.status)}`}>
						{this.getStatusLabel(exchange.status)}
					</span>
				),
			},
			{
				key: "comments",
				header: t("shiftExchanges.requestComments"),
				className: "exchange-table-comments",
				render: (exchange) => exchange.comments || "—",
			},
			{
				key: "answer_comments",
				header: t("shiftExchanges.answerComments"),
				className: "exchange-table-comments",
				render: (exchange) => exchange.answer_comments || "—",
			},
			{
				key: "requested",
				header: t("shiftExchanges.requestedOn"),
				render: (exchange) => <Moment format="D/MM/YYYY">{exchange.requested}</Moment>,
			},
		];
	};

	getMobileTableRows = () =>
		this.props.exchanges.map((exchange) => {
			const requester = exchange.requester_employee;
			const target = exchange.target_employee;
			return (
				<tr key={exchange.id} className="shift-exchange-mobile-row">
					<td>
						<div className="shift-exchange-mobile-participants">
							<strong>{requester?.name} {requester?.surname}</strong>
							<span>›</span>
							<strong>{target?.name} {target?.surname}</strong>
						</div>
						<div className="shift-exchange-mobile-shifts">
							<div>
								<Moment format="D/MM/YYYY">{exchange.requester_plan?.day}</Moment>
								{this.getShiftBadge(exchange.requester_plan?.assignments?.[0])}
							</div>
							<FiRepeat />
							<div>
								<Moment format="D/MM/YYYY">{exchange.target_plan?.day}</Moment>
								{this.getShiftBadge(exchange.target_plan?.assignments?.[0])}
							</div>
						</div>
						{exchange.comments && (
							<p className="shift-exchange-mobile-comment">
								<strong>{this.props.t("shiftExchanges.requestComments")}:</strong>{" "}
								{exchange.comments}
							</p>
						)}
						{exchange.answer_comments && (
							<p className="shift-exchange-mobile-comment">
								<strong>{this.props.t("shiftExchanges.answerComments")}:</strong>{" "}
								{exchange.answer_comments}
							</p>
						)}
						<div className="shift-exchange-mobile-footer">
							<span className={`estado ${this.getStatusClass(exchange.status)}`}>
								{this.getStatusLabel(exchange.status)}
							</span>
							<span>
								{this.props.t("shiftExchanges.requestedOn")} {" "}
								<Moment format="D/MM/YYYY">{exchange.requested}</Moment>
							</span>
						</div>
					</td>
				</tr>
			);
		});

	renderTable() {
		const { t } = this.props;
		if (this.props.exchanges.length === 0) {
			return <p className="no-results">{t("shiftExchanges.noResults")}</p>;
		}

		const desktopTable = (
			<DataTable
				tableClassName="table table-absences table-desktop table-hover shift-exchanges-table"
				tableStyle={{ backgroundColor: "#ffffff" }}
				columns={this.getTableColumns()}
				rows={this.props.exchanges}
				rowKey={(exchange) => exchange.id}
				emptyMessage={t("shiftExchanges.noResults")}
				showHeaderSortAffix={false}
				actionsColumn={
					this.props.showManagedActions
						? {
								render: (exchange) => this.renderManagedActions(exchange),
								className: "td-actions",
							}
						: undefined
				}
			/>
		);

		return (
			<>
				<Mobile>
					<div className="row list-preferences">{this.getRows()}</div>
				</Mobile>
				<Tablet>{desktopTable}</Tablet>
				<Desktop>{desktopTable}</Desktop>
			</>
		);
	}

	render() {
		if (this.props.isListView) return this.renderTable();
		if (this.props.exchanges.length === 0) {
			return (
				<p className="no-results">{this.props.t("shiftExchanges.noResults")}</p>
			);
		}
		return <div className="row list-preferences">{this.getRows()}</div>;
	}
}

const mapStateToProps = (reducers) => ({
	user: reducers.authReducer.user,
});

export default connect(mapStateToProps, null)(withTranslation()(ShiftExchangesList));
